<template>
  <CBox
    bg="#FFFFFF"
    border="1px solid #DADADA"
    borderRadius="8px"
    p="20px"
  >
    <CFlex
      alignItems="center"
      mb="16px"
    >
      <OmtIcons
        name="message-lines"
        size="lg"
        color="var(--colors-light-primary-navy-blue)"
        mr="8px"
      />
      <OmtTypography
        as="h2-bold"
        color="var(--colors-light-primary-navy-blue)"
      >
        {{ recados.length > 1 ? "Recados da equipe de saúde" : "Recado da equipe de saúde" }}
      </OmtTypography>
    </CFlex>
    <ul class="recados">
      <li
        v-for="(recado, idx) in recados"
        :key="'recado' + idx"
        class="recado"
      >
        <OmtTypography
          as="p1"
          color="#4E4E4E"
          class="recado__texto"
        >
          {{ recado }}
        </OmtTypography>
      </li>
    </ul>
  </CBox>
</template>

<script>
import { CBox, CFlex } from "@chakra-ui/vue";

/**
 * Recados da equipe de saude sobre a analise de pele, em lista com marcadores.
 * @prop { Array } recados textos (reviewerNotes do relatorio da Plataforma Wellness)
 */
export default {
  name: "SkiniverRecados",
  components: { CBox, CFlex },
  props: {
    recados: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
/* Espacamento via gap: o reset global zera margin-top de <p> com !important. */
.recados {
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Marcador proprio (bolinha azul) alinhado com a primeira linha do texto. */
.recado {
  position: relative;
  padding-left: 20px;
}

.recado::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1ca0ff;
}

/* O recado pode vir com quebras de linha (ex.: texto editado pela equipe). */
.recado__texto {
  white-space: pre-line;
}
</style>
